/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Select_Previous_EventInputs */

const en_shortcut_keys_name_select_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Previous Event`)
};

const fr_shortcut_keys_name_select_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner l'evenement precedent`)
};

const de_shortcut_keys_name_select_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriges Ereignis auswählen`)
};

const it_shortcut_keys_name_select_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona evento precedente`)
};

const ru_shortcut_keys_name_select_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите предыдущее событие`)
};

const es_shortcut_keys_name_select_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar evento anterior`)
};

const zh_cn2_shortcut_keys_name_select_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择上一个事件`)
};

const ja_shortcut_keys_name_select_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のイベントを選択`)
};

const hi_shortcut_keys_name_select_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला कार्यक्रम चुनें`)
};

const pt_pt2_shortcut_keys_name_select_previous_event = /** @type {(inputs: Shortcut_Keys_Name_Select_Previous_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o evento anterior`)
};

/**
* | output |
* | --- |
* | "Select Previous Event" |
*
* @param {Shortcut_Keys_Name_Select_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_select_previous_event = /** @type {((inputs?: Shortcut_Keys_Name_Select_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Select_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_select_previous_event(inputs)
	if (locale === "de") return de_shortcut_keys_name_select_previous_event(inputs)
	if (locale === "it") return it_shortcut_keys_name_select_previous_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_select_previous_event(inputs)
	if (locale === "es") return es_shortcut_keys_name_select_previous_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_select_previous_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_select_previous_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_select_previous_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_select_previous_event(inputs)
	return en_shortcut_keys_name_select_previous_event(inputs)
});